<template>
    <expert-stock-out-form ref="esoForm" :caseTypeId="caseTypeId" />
</template>
<script>

  import ExpertStockOutForm from '@/epp/expertmain/expertInfo/common/ExpertStockOutForm.vue'

  export default {
    name: 'ExpertStockOutAdd',
    components: {
      ExpertStockOutForm
    },
    data () {
      return {
        id: this.$route.query.id,
        caseTypeId: this.$route.query.caseTypeId,
        form: {},
        loading: false
      }
    },
    computed: {
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style></style>
